<template>
  <v-container fluid class="storage-view">
    <v-row justify="start">
      <v-col cols="3">
        <v-card class="grey lighten-4">
          <v-card-title class="text-uppercase">
            Storages <v-spacer /><storage-form>
              <v-btn color="primary" dark>
                Add Storage
              </v-btn>
            </storage-form>
          </v-card-title>
          <v-card-text>
            <storage-card
              @selected="selectedStorage"
              v-for="storage in storages"
              :key="storage.name"
              :storage="storage"
              :isSelected="isSelected(storage.name)"
            ></storage-card>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="9" v-if="hasStorageSelected">
        <container-list
          :containers="currentStorageContainers"
          :storage="currentStorage"
        >
        </container-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import StorageForm from './StorageForm.vue'
import ContainerList from './ContainerList.vue'
import StorageCard from './StorageCard.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapActions } = createNamespacedHelpers('storage')
export default {
  name: 'StorageList',
  components: {
    StorageForm,
    StorageCard,
    ContainerList
  },
  props: {
    storages: {
      type: Array,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState(['currentStorage']),
    hasStorageSelected() {
      return this.currentStorage ? true : false
    },
    currentStorageContainers() {
      if (this.currentStorage && this.currentStorage.containers) {
        return Object.entries(this.currentStorage.containers).map(([k, v]) => {
          return {
            name: k,
            ...v
          }
        })
      } else {
        return []
      }
    }
  },
  methods: {
    ...mapActions(['setCurrentStorage', 'setCurrentContainer']),
    isSelected(name) {
      return this.currentStorage && this.currentStorage.name === name
        ? true
        : false
    },
    selectedStorage(storage) {
      this.setCurrentStorage(storage)
      this.setCurrentContainer(null)
    }
  }
}
</script>

<style></style>
